import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Expansive Residences with Majestic Views",
    "Designed by Renowned Architect Hafeez Contractor",
    "4-Level Amenity Zone Spread Across 1,10,000 sq.ft.",
  ];
  const highlights2 = [
    "Proximity to Wagle Estate – A Thriving Industrial Hub",
    "Seamless Connectivity to Major Highways and Public Transport",
    "Nestled Between Yogi Hills and SGNP",
  ];
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          {project} - Overview
        </h1>

        <p>
          Welcome to Ashar Merac, a luxurious residential development nestled in
          the Mulund Thane Corridor (MTC) at Shree Nagar, Thane. This expansive
          project offers 1, 2, 3 & 4 BHK residences with majestic views of Yogi
          Hills and the Sanjay Gandhi National Park (SGNP). Designed by the
          renowned architect Padma Bhushan Hafeez Contractor, Ashar Merac
          seamlessly blends modern architecture with natural serenity.
          <br />
          The project boasts a 4-level amenity zone spread across 1,10,000
          sq.ft., providing residents with a plethora of leisure and comfort
          facilities. Its strategic location ensures seamless connectivity to
          major business hubs, educational institutions, and entertainment
          centers, making it an ideal choice for those seeking a balanced urban
          lifestyle.
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy text-capitalize">
              <li>
                <span>Spacious 1 & 2 BHK Residences</span>
              </li>
              <li>
                <span>
                  Iconic high-rise 46-Storey Towers with premium architecture
                </span>
              </li>
              <li>
                <span>
                  Unmatched Investment Potential with high appreciation value
                </span>
              </li>
            </ul> */}

            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy">
              <li>
                <span>Smart layouts for modern families</span>
              </li>
              <li>
                <span>
                  Seamless Connectivity to EEH, Railway Station & Malls
                </span>
              </li>
              <li>
                <span>
                  Marvellous Amenities like Clubhouse, Swimming Pool & More
                </span>
              </li>
            </ul> */}
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
